export const environment = {
  production: true,
  API: "https://minhacoopapi.azurewebsites.net/api/v2/",
  siteKey: "6LelPIQlAAAAAHHDv_Zssec6hOPdg8wyA4ucPTkI"
};